import { Fragment } from 'react';
import { MdChevronRight } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { Text } from 'components';
import { getRoutePathsAndName } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

interface RouteButtonProps {
  path: string;
  pageName: string;
  disabled?: boolean;
}

function RouteButton({ path, pageName, disabled }: RouteButtonProps) {
  const navigate = useNavigate();

  return (
    <S.Button onClick={() => navigate(path)} disabled={disabled}>
      <Text
        size={FontSize.font12}
        weight={disabled ? FontWeight.bold : FontWeight.regular}
      >
        {pageName}
      </Text>
    </S.Button>
  );
}

function ChevronIcon() {
  return (
    <S.Icon>
      <MdChevronRight size={24} />
    </S.Icon>
  );
}

export function Breadcrumb() {
  const { pathname } = useLocation();
  const pages = getRoutePathsAndName(pathname);

  const renderPaths = pages.map((value, index) => {
    const { name, path } = value;
    const isLastItem = pages.length === index + 1;

    return (
      <Fragment key={path}>
        <RouteButton path={path} pageName={name} disabled={isLastItem} />
        {!isLastItem && <ChevronIcon />}
      </Fragment>
    );
  });

  return (
    <S.Wrapper>
      <RouteButton path="/" pageName="Home" />

      <ChevronIcon />

      {renderPaths}
    </S.Wrapper>
  );
}
